import gql from "graphql-tag";

export const resetUserOnboarding = gql`
  mutation ResetUserOnboarding {
    ResetUserOnboarding {
      success
    }
  }
`;
